import React, { useEffect, useState, useNavigate } from 'react';
import { ScheduleMeeting } from 'react-schedule-meeting';
import Box from '@mui/material/Box';
import { callApi } from "../../common/api";
import ScheduleView from './ScheduleView';
import CustomisedButton from '../../common/components/CustomisedButton';
import "../Investor/style/ScheduleMeeting.css";
import { timeSlotDifferenceMy } from './scTest';
import CustomizedSnackbars from '../alert/alert';
import MeetingHistory from '../Investor/MeetingHistory';
export default function ScheduleMeetingComponent({ meetingId,statusChange,setStatusChange,handleClose, meetingStatus, id, startupId, reshceduleReason }) {
 
  const [selectedTimeslot, setSelectedTimeslot] = React.useState({});
  const [next, setNext] = React.useState(false);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [time, selectTime] = React.useState(30);
  const [endTime, setEndTime] = React.useState(null);
  const [data, setData] = React.useState({})
  const [snackBarMsg, setSnackBarMsg] = useState({
    message: "",
    severity: "success",
    open: false,
  });

  const [slotsAvailable, setSlotsAvailable] = React.useState([])


  const availableTimeslots = [0, 1, 2, 3, 4, 5].map((id) => {
    return {
      startTime: new Date(new Date(new Date().setDate(new Date().getDate() + id)).setHours(9, 0, 0, 0)),
      endTime: new Date(new Date(new Date().setDate(new Date().getDate() + id)).setHours(17, 0, 0, 0)),
    };
  });


  function formatDate(date) {
    const inputDate = new Date(date);
    const convertedDateString = inputDate.toISOString(); // Convert to ISO string
    return convertedDateString;
  }

  const handleTimeslotSelect = (timeslot) => {
    setSelectedTimeslot(timeslot);
    calculateEndTime(timeslot.startTime, time);
  };


  const getTimeslots = async () => {
    try {
      const response = await callApi("get", `/meeting/getMeeting?StartupId=${startupId}`)
      const bookedTimeslot = response?.data?.response?.data?.user;
      let arr = []
      for (let data of bookedTimeslot) {
        let obj = {
          startTime: new Date(data.meetingStart),
          endTime: new Date(data.meetingEnd)
        }
        arr.push(obj)
      }

      const availableTimeSlotsLessUnavailableTimeSlots = timeSlotDifferenceMy(availableTimeslots, arr);
      setSlotsAvailable(availableTimeSlotsLessUnavailableTimeSlots)

    } catch (err) {
      console.log(err)
    }
  }


  useEffect(() => {
    getTimeslots()
  }, [])


  const calculateEndTime = (startTime, meetingTime) => {
    const endTime = new Date(startTime);
    endTime.setMinutes(endTime.getMinutes() + meetingTime);
    setEndTime(endTime);
  };

  const handleTimeSelection = (selectedMeetingTime) => {
    selectTime(selectedMeetingTime);
    if (selectedTimeslot.startTime) {
      calculateEndTime(selectedTimeslot.startTime, selectedMeetingTime);
    }
    handleDropdownClose();
  };

  const handleNextClick = async () => {

    if (selectedTimeslot.startTime && endTime) {
      const requestData = {
        start: formatDate(selectedTimeslot.startTime), // Format start time to ISO string
        end: formatDate(endTime), // Format end time to ISO string
        startupId: startupId,
        id: id
      };
      const obj = {
        meetingId: meetingId,
        start: requestData.start,
        end: requestData.end,
        reason: reshceduleReason,
        startupId: startupId
      }


      try {
        if (meetingStatus === "CANCELLED" || meetingStatus === "CREATE") {
          const response = await callApi("post", "meeting/meeting", requestData, { "Content-Type": "application/json" }, true, true);
          if (!response.status) {
            setSnackBarMsg({
              message: "Cannot schedule a meeting on this time.",
              severity: "error",
              open: true
            })
          }

          setData(response?.data?.response?.data)
          if (response?.data?.response?.status) {
            if(setStatusChange){
              setStatusChange(!statusChange)
            }
            setNext(true)
          }
        } else {
          const response = await callApi("post", "meeting/reschedule", obj);
          setData(response?.data?.response?.data?.booking)
          if (response?.data?.response?.data?.booking) {
            if(setStatusChange){
              setStatusChange(!statusChange)
            }
            setNext(true)
          }
        }
      } catch (error) {
        console.log(error, "ye error hai")
        if (error) {
          setSnackBarMsg({
            message: "On this time the meeting is already Exist",
            severity: "error",
            open: true
          })
          return
        }
        console.error('Error creating meeting:', error);
      }
    }
    else if (Object.keys(selectedTimeslot).length === 0) {
      setSnackBarMsg({
        message: "Timeslot not selected",
        severity: "error",
        open: true
      })
    }
  };
  // const navigate = useNavigate();
  const handleDropdownOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleDropdownClose = () => {
    setAnchorEl(null);
  };
  const handleSkipButton = () => {
    handleClose();
  }
  // const handleSkipButton = () => {
  //   window.location.reload();
  // }
    
  setTimeout(() => {
    if (next) {
      handleClose()
    }
  }, 100000)


  const closeButton = () => {
    handleClose()
  }
 
  return (
    <>
      {!next ? (
        <Box className="box-container-meet" >
          <div style={{ position: 'relative', display: 'flex', justifyContent: 'left', alignItems: 'left', height: '50px' }}>
  <h2  className="select-meeting-time">Select Meeting Time</h2>
  <button
    className='skipButton'
    onClick={handleSkipButton}
    style={{
      position: 'absolute',
      right: '20px',
      top: '10px',
      borderRadius: '10px',
      color: 'white',
      backgroundColor: 'transparent',
      border: '1px solid white',
      padding: '5px 20px',
      alignItems: 'center',
      textAlign: 'center',
      '&:hover': { color: 'blue' }
    }}
  >
    Skip
  </button>
</div>

          {/* <div className='meeting-schedule'>
            <Button onClick={handleDropdownOpen} style={{ color: 'black', backgroundColor: 'white' }}>
              Meeting Schedule <KeyboardArrowDownIcon sx={{ color: "black" }} />
            </Button>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleDropdownClose}
            >
              <MenuItem onClick={() => handleTimeSelection(30)}>30 Minutes</MenuItem>
              <MenuItem onClick={() => handleTimeSelection(60)}>60 Minutes</MenuItem>
              <MenuItem onClick={() => handleTimeSelection(90)}>90 Minutes</MenuItem>
              <MenuItem onClick={() => handleTimeSelection(120)}>120 Minutes</MenuItem>
            </Menu>
          </div> */}
          {slotsAvailable.length > 0 ? <ScheduleMeeting
            borderRadius={10}
            primaryColor="#000000" // Set color to black
            eventDurationInMinutes={30}
            availableTimeslots={slotsAvailable}
            onStartTimeSelect={handleTimeslotSelect}
            renderAvailableTimeslot={(timeslot) => (
              <div key={timeslot.id} style={{ display: 'flex', justifyContent: 'space-between', border: "5px solid red" }}>
                <div>{timeslot.startTime.toLocaleDateString()}</div>
                <div>
                  {timeslot.startTime.toLocaleTimeString()} - {timeslot.endTime.toLocaleTimeString()}
                </div>
              </div>
            )}
          /> : <></>}
          <Box className="customised-buttons" style={{ gap: "20px", display: "flex", marginLeft: "20px" }}>
            <CustomisedButton width="150px" children="Cancel" variant="outlined" handleClick={handleClose} />
            <CustomisedButton handleClick={handleNextClick} width="150px" children="Next" variant="outlined" />

          </Box>
          <CustomizedSnackbars
            msgData={snackBarMsg}
            setMsgData={setSnackBarMsg} />
        </Box>
      ) : <ScheduleView Time={data} closeButton={closeButton} />}

    </>
  );
}
